import { Button } from '@creanizer/ui'
import { Card } from '@creanizer/ui'
import { Badge } from '@creanizer/ui'
import { Copy, BookOpen, Clock } from 'lucide-react'
import type { CommunityHistory } from '@creanizer/types'

interface CommunityHistoryProps {
  history: CommunityHistory
  onCopy: (text: string) => void
}

export function CommunityHistory({ history, onCopy }: CommunityHistoryProps) {
  const formatHistory = () => {
    const lines: string[] = []
    lines.push('■ 創立物語')
    lines.push(history.foundingStory)
    lines.push('')
    lines.push('■ 年表')
    if (Array.isArray(history.timeline)) {
      history.timeline.forEach(event => {
        lines.push(`${event.year}: ${event.event}`)
      })
    }
    return lines.join('\n')
  }

  return (
    <div className="space-y-4">
      <div className="flex justify-between items-center mb-4">
        <h3 className="text-lg font-semibold">歴史</h3>
        <Button
          size="sm"
          variant="outline"
          onClick={() => onCopy(formatHistory())}
        >
          <Copy className="h-4 w-4 mr-1" />
          コピー
        </Button>
      </div>

      <Card className="p-4">
        <div className="flex items-start gap-3">
          <BookOpen className="h-5 w-5 text-teal-500 mt-1" />
          <div className="flex-1">
            <h4 className="font-semibold mb-2">創立物語</h4>
            <p className="text-sm leading-relaxed">{history.foundingStory}</p>
          </div>
        </div>
      </Card>

      <div className="space-y-3">
        <div className="flex items-center gap-2">
          <Clock className="h-5 w-5 text-orange-500" />
          <h4 className="font-semibold">年表</h4>
        </div>
        
        <div className="space-y-2">
          {Array.isArray(history.timeline) && history.timeline.map((event, index) => (
            <Card key={index} className="p-3">
              <div className="flex items-start gap-3">
                <Badge variant="secondary" className="shrink-0">
                  {event.year}
                </Badge>
                <p className="text-sm leading-relaxed">
                  {event.event}
                </p>
              </div>
            </Card>
          ))}
        </div>
      </div>
    </div>
  )
}